// Determine environment
const environment = import.meta.env.VITE_ENVIRONMENT_NAME || 'staging';

export const getDatabaseUserLink = (userId: string) => {
  if (environment === 'production') {
    return `https://console.firebase.google.com/u/0/project/obseess-d7895/firestore/databases/-default-/data/~2Fuser_info~2F${userId}`;
  } else {
    return `https://console.firebase.google.com/u/0/project/obseess-staging/firestore/databases/-default-/data/~2Fuser_info~2F${userId}`;
  }
};

export const getRevenueCatCustomerLink = (userId: string) => {
  if (environment === 'production') {
    return `https://app.revenuecat.com/projects/4f32571f/customers/${userId}`;
  } else {
    return `https://app.revenuecat.com/projects/bdda4317/customers/${userId}`;
  }
};

export const getQuestLink = (userId: string, journeyDayId: string, questId: string) => {
  if (environment === 'production') {
    return `https://console.firebase.google.com/u/0/project/obseess-d7895/firestore/databases/-default-/data/~2Fuser_info~2F${userId}/quest_journey~2F${journeyDayId}/quests~2F${questId}`;
  } else {
    return `https://console.firebase.google.com/u/0/project/obseess-staging/firestore/databases/-default-/data/~2Fuser_info~2F${userId}/quest_journey~2F${journeyDayId}/quests~2F${questId}`;
  }
};

export const getQuestTemplateLink = (journeyDayId: string, questTemplateId: string) => {
  if (environment === 'production') {
    return `https://console.firebase.google.com/u/0/project/obseess-d7895/firestore/databases/-default-/data/~2Fquest_journey_templates~2F${journeyDayId}/quest_templates~2F${questTemplateId}`;
  } else {
    return `https://console.firebase.google.com/u/0/project/obseess-staging/firestore/databases/-default-/data/~2Fquest_journey_templates~2F${journeyDayId}/quest_templates~2F${questTemplateId}`;
  }
};

export const getJourneyItemTemplateLink = (chapterId: string, sectionId: string, itemId: string) => {
  const path = `~2Fjourney_templates~2F${chapterId}~2Fsections~2F${sectionId}~2Fitems~2F${itemId}`;
  if (environment === 'production') {
    return `https://console.firebase.google.com/u/0/project/obseess-d7895/firestore/databases/-default-/data/${path}`;
  } else {
    return `https://console.firebase.google.com/u/0/project/obseess-staging/firestore/databases/-default-/data/${path}`;
  }
};

export const getJourneyUserItemLink = (userId: string, chapterId: string, sectionId: string, itemId: string) => {
  const path = `~2Fuser_info~2F${userId}~2Fjourney_chapters~2F${chapterId}~2Fsections~2F${sectionId}~2Fitems~2F${itemId}`;
  if (environment === 'production') {
    return `https://console.firebase.google.com/u/0/project/obseess-d7895/firestore/databases/-default-/data/${path}`;
  } else {
    return `https://console.firebase.google.com/u/0/project/obseess-staging/firestore/databases/-default-/data/${path}`;
  }
};

export const getDbAdminLink = (userId: string) => {
  if (environment === 'production') {
    return `https://admin.obsessless.org/user-profile/${userId}`;
  } else if (environment === 'staging') {
    return `https://staging.admin.obsessless.org/user-profile/${userId}`;
  } else {
    return `http://localhost:5174/user-profile/${userId}`;
  }
};
